import $ from "jquery";

export function handleAccordion() {
    $("body").on("click", ".js-load-more", function () {
        $("body").find(".logos-section__logo-grid-wrap").stop().slideToggle();
        const $btn = $(this);
        const see_less = $btn.attr('data-less');
        const see_more = $btn.attr('data-more');

        let text = $btn.text() === see_less ? see_more : see_less;
        $btn.text(text);
    });
}
